export default __webpack_public_path__ + "locales/sk/Ldap.json?hash=64cb08a4054bed7ef679783c8a7393f3";